module.exports = __webpack_public_path__ + "media/fonts/SFProText-Heavy-ef5cebd3f78809472225328ceeda937e.woff";